import { 
	getExternalApi,
	postExternalApi,
	getFilterCriteriaSortingParams,
	appConfig,
	dateToString
} from 'app-core/Data';

/* NetworkShow */

function getNetworkShows(pageIndex, limit, opts) {
	if (opts?.byKey)
		return getNetworkShow(opts.byKey).then(r => ({ Results: r }));
	return getExternalApi('NetworkShow/List', `page=${pageIndex + 1}${getFilterCriteriaSortingParams(opts)}`, limit);
}

function getNetworkShow(id) {
	return getExternalApi('NetworkShow/Get', `id=${id}`);
}

function getNetworkShowNewShowDate(id, airDateTime) {
	const airDateTimeParam = airDateTime ? `&airDateTime=${dateToString(airDateTime)}` : ''
	return getExternalApi('NetworkShow/GetNewShowDate', `id=${id}${airDateTimeParam}`);
}

function getAvailableNetworkShows(pageIndex, limit, opts) {
	if (opts?.byKey)
		return getNetworkShow(opts.byKey).then(r => ({ Results: r }));
	opts = { defSorting: [ { selector: 'ScheduleStartDateGmt', desc: true }], ...(opts || {}) };
	return getExternalApi('NetworkShow/GetAvailableShows', `page=${pageIndex + 1}${getFilterCriteriaSortingParams(opts)}&filterOutMine=false`, limit);
}

/* NetworkShowTalent */

function getNetworkShowTalent(id) {
	return getExternalApi('NetworkShowTalent/Get', `id=${id}`);
}

function getNetworkShowTalents(pageIndex, limit, opts) {
	if (opts?.byKey)
		return getNetworkShowTalent(opts.byKey).then(r => ({ Results: r }));
	opts = { defSorting: [ { selector: 'Name' }], ...(opts || {}) };
	return getExternalApi('NetworkShowTalent/List', `page=${pageIndex + 1}${getFilterCriteriaSortingParams(opts)}`, limit);
}

function getNetworkShowLinkedTalents(pageIndex, limit, opts, networkShowId) {
	if (opts?.byKey)
		return getNetworkShowTalent(opts.byKey).then(r => ({ Results: r }));
	opts = { defSorting: [ { selector: 'Name' }], ...(opts || {}) };
	return getExternalApi('NetworkShow/GetCollectionTalents', `page=${pageIndex + 1}&rootObjectId=${networkShowId}${getFilterCriteriaSortingParams(opts)}`, limit);
}

function createUpdateNetworkShowTalent(item) {
	return postExternalApi('NetworkShowTalent/CreateUpdate', item);
}

function deleteNetworkShowTalent(id) {
	return postExternalApi('NetworkShowTalent/Delete', [id]);
}

/* NetworkShowCategory */

function getNetworkShowCategory(id) {
	return getExternalApi('NetworkShowCategory/Get', `id=${id}`);
}

function getNetworkShowCategories(pageIndex, limit, opts) {
	if (opts?.byKey)
		return getNetworkShowCategory(opts.byKey).then(r => ({ Results: r }));
	opts = { defSorting: [ { selector: 'Name' }], ...(opts || {}) };
	return getExternalApi('NetworkShowCategory/List', `page=${pageIndex + 1}${getFilterCriteriaSortingParams(opts)}`, limit);
}

function getNetworkShowLinkedCategories(pageIndex, limit, opts, networkShowId) {
	if (opts?.byKey)
		return getNetworkShowCategory(opts.byKey).then(r => ({ Results: r }));
	opts = { defSorting: [ { selector: 'Name' }], ...(opts || {}) };
	return getExternalApi('NetworkShow/GetCollectionCategories', `page=${pageIndex + 1}&rootObjectId=${networkShowId}${getFilterCriteriaSortingParams(opts)}`, limit);
}

function createUpdateNetworkShowCategory(item) {
	return postExternalApi('NetworkShowCategory/CreateUpdate', item);
}

function deleteNetworkShowCategory(id) {
	return postExternalApi('NetworkShowCategory/Delete', [id]);
}

/* NetworkShowFormat */

function getNetworkShowFormat(id) {
	return getExternalApi('NetworkFormat/Get', `id=${id}`);
}

function getNetworkShowFormats(pageIndex, limit, opts) {
	if (opts?.byKey)
		return getNetworkShowFormat(opts.byKey).then(r => ({ Results: r }));
	opts = { defSorting: [ { selector: 'Name' }], ...(opts || {}) };
	return getExternalApi('NetworkFormat/List', `page=${pageIndex + 1}${getFilterCriteriaSortingParams(opts)}`, limit);
}

function getNetworkShowLinkedFormats(pageIndex, limit, opts, networkShowId) {
	if (opts?.byKey)
		return getNetworkShowFormat(opts.byKey).then(r => ({ Results: r }));
	opts = { defSorting: [ { selector: 'Name' }], ...(opts || {}) };
	return getExternalApi('NetworkShow/GetCollectionFormats', `page=${pageIndex + 1}&rootObjectId=${networkShowId}${getFilterCriteriaSortingParams(opts)}`, limit);
}

function createUpdateNetworkShowFormat(item) {
	return postExternalApi('NetworkFormat/CreateUpdate', item);
}

function deleteNetworkShowFormat(id) {
	return postExternalApi('NetworkFormat/Delete', [id]);
}

/* NetworkShowClock */

function getNetworkShowClock(id) {
	return getExternalApi('NetworkShowClock/Get', `id=${id}`);
}

function getNetworkShowClocks(pageIndex, limit, opts, showId) {
	if (opts?.byKey)
		return getNetworkShowClock(opts.byKey).then(r => ({ Results: r }));
	opts = { defSorting: [ { selector: 'EffectiveDate', desc: true }], ...(opts || {}) };
	return getExternalApi('NetworkShowClock/List', `showOid=${showId}&page=${pageIndex + 1}${getFilterCriteriaSortingParams(opts)}`, limit);
}

function createUpdateNetworkShowClock(item) {
	return postExternalApi('NetworkShowClock/CreateUpdate', { ...item, EffectiveDate: dateToString(item.EffectiveDate) });
}

function deleteNetworkShowClock(id) {
	return postExternalApi('NetworkShowClock/Delete', [id]);
}

/* NetworkShowCue */

function getNetworkShowCue(id) {
	return getExternalApi('NetworkShowCue/Get', `id=${id}`);
}

function getNetworkShowCues(pageIndex, limit, opts) {
	if (opts?.byKey)
		return getNetworkShowCue(opts.byKey).then(r => ({ Results: r }));
	opts = { defSorting: [ { selector: 'Name' }], ...(opts || {}) };
	return getExternalApi('NetworkShowCue/List', `page=${pageIndex + 1}${getFilterCriteriaSortingParams(opts)}`, limit);
}

function createUpdateNetworkShowCue(item) {
	return postExternalApi('NetworkShowCue/CreateUpdate', item);
}

function deleteNetworkShowCue(id) {
	return postExternalApi('NetworkShowCue/Delete', [id]);
}

/* NetworkShowEpisode */

function getNetworkShowEpisode(id) {
	return getExternalApi('NetworkShowEpisode/Get', `id=${id}`);
}

function getNetworkShowEpisodes(pageIndex, limit, opts, showId) {
	if (opts?.byKey)
		return getNetworkShowEpisode(opts.byKey).then(r => ({ Results: r }));
	opts = { defSorting: [ { selector: 'AirDateTime', desc: true }], ...(opts || {}) };
	return getExternalApi('NetworkShowEpisode/List', `showOid=${showId}&page=${pageIndex + 1}${getFilterCriteriaSortingParams(opts)}`, limit);
}

function createUpdateNetworkShowEpisode(item) {
	return postExternalApi('NetworkShowEpisode/CreateUpdate', item);
}

function deleteNetworkShowEpisode(id) {
	return postExternalApi('NetworkShowEpisode/Delete', [id]);
}

function createEpisodeFromClock(data) {
	return postExternalApi('NetworkShowEpisode/CreateEpisodeFromClock', data);
}

/* NetworkShowAffiliate */

function getNetworkShowAffiliate(id) {
	return getExternalApi('NetworkShowAffiliate/Get', `id=${id}`);
}

function getNetworkShowAffiliates(pageIndex, limit, opts) {
	if (opts?.byKey)
		return getNetworkShowAffiliate(opts.byKey).then(r => ({ Results: r }));
	return getExternalApi('NetworkShowAffiliate/List', `page=${pageIndex + 1}${getFilterCriteriaSortingParams(opts)}`, limit);
}

function createUpdateNetworkShowAffiliate(item) {
	return postExternalApi('NetworkShowAffiliate/CreateUpdate', item);
}

function deleteNetworkShowAffiliate(id) {
	return postExternalApi('NetworkShowAffiliate/Delete', [id]);
}

/* NetworkShowAffiliateSchedule */

function getNetworkShowAffiliateSchedule(id) {
	return getExternalApi('NetworkShowAffiliateSchedule/Get', `id=${id}`);
}

function getNetworkShowAffiliateSchedules(pageIndex, limit, opts, affilaiteId) {
	if (opts?.byKey)
		return getNetworkShowAffiliateSchedule(opts.byKey).then(r => ({ Results: r }));
	return getExternalApi('NetworkShowAffiliateSchedule/List', `affiliateOid=${affilaiteId}&page=${pageIndex + 1}${getFilterCriteriaSortingParams(opts)}`, limit);
}

function createUpdateNetworkShowAffiliateSchedule(item) {
	return postExternalApi('NetworkShowAffiliateSchedule/CreateUpdate', item);
}

function deleteNetworkShowAffiliateSchedule(id) {
	return postExternalApi('NetworkShowAffiliateSchedule/Delete', [id]);
}

export default {
	getNetworkShows,
	getNetworkShow,
	getNetworkShowNewShowDate,
	getAvailableNetworkShows,
	getNetworkShowTalents,
	getNetworkShowTalent,
	getNetworkShowLinkedTalents,
	createUpdateNetworkShowTalent,
	deleteNetworkShowTalent,
	getNetworkShowCategories,
	getNetworkShowCategory,
	getNetworkShowLinkedCategories,
	createUpdateNetworkShowCategory,
	deleteNetworkShowCategory,
	getNetworkShowFormats,
	getNetworkShowFormat,
	getNetworkShowLinkedFormats,
	createUpdateNetworkShowFormat,
	deleteNetworkShowFormat,
	getNetworkShowClocks,
	getNetworkShowClock,
	createUpdateNetworkShowClock,
	deleteNetworkShowClock,
	getNetworkShowCue,
	getNetworkShowCues,
	createUpdateNetworkShowCue,
	deleteNetworkShowCue,
	getNetworkShowEpisode,
	getNetworkShowEpisodes,
	createUpdateNetworkShowEpisode,
	deleteNetworkShowEpisode,
	createEpisodeFromClock,
	getNetworkShowAffiliate,
	getNetworkShowAffiliates,
	createUpdateNetworkShowAffiliate,
	deleteNetworkShowAffiliate,
	getNetworkShowAffiliateSchedule,
	getNetworkShowAffiliateSchedules,
	createUpdateNetworkShowAffiliateSchedule,
	deleteNetworkShowAffiliateSchedule,
};
